import React, { useState, useMemo } from "react";
import VisualizacionBomberos from "../components/VisualizacionBomberos";
import MenuLateralBombero from "../components/MenuLateralBombero";
import TextBannerUnderLogo from "../components/TextBannerUnderLogo";

export default function Compania4() {
  const [mostrarMenu, setMostrarMenu] = useState(false);
  const [citaciones, setCitaciones] = useState(0);

  const baseTop = 70;
  const altoPorCitacion = 48;

  const offsetTop = useMemo(
    () => baseTop + citaciones * altoPorCitacion,
    [citaciones]
  );

  const handleCitacionesChange = (cantidad) => {
    setCitaciones(Number.isFinite(cantidad) ? cantidad : 0);
  };

  return (
    <>
      <div style={{ position: "fixed", top: offsetTop, left: 12, zIndex: 2000 }}>
        <button
          onClick={() => setMostrarMenu(true)}
          style={{
            background: "#f5f5f5",
            border: "1px solid #ddd",
            borderRadius: 24,
            padding: "10px 14px",
            fontWeight: 600,
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            cursor: "pointer",
          }}
          aria-label="Abrir menú"
        >
          ☰ Menú
        </button>
      </div>

      <MenuLateralBombero isOpen={mostrarMenu} onClose={() => setMostrarMenu(false)} />

      <div style={{ paddingTop: 12 }}>
        <TextBannerUnderLogo cia="Cuarta Compañía" />
      </div>

      <VisualizacionBomberos
        companiaFiltro="Cuarta Compañía"
        onCitacionesChange={handleCitacionesChange}
      />
    </>
  );
}
